import { render, staticRenderFns } from "./ImplementationTable.vue?vue&type=template&id=23c49126&scoped=true"
import script from "./ImplementationTable.vue?vue&type=script&lang=js"
export * from "./ImplementationTable.vue?vue&type=script&lang=js"
import style0 from "./ImplementationTable.vue?vue&type=style&index=0&id=23c49126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c49126",
  null
  
)

export default component.exports